import * as React from 'react';
import * as ContractRepository from '../../../Repository/ContractRepository';
import { ContractListData } from 'tree-wallet-client';
import message from 'antd/es/message';
import { GlobalContext } from '../../../Contexts/GlobalContext';
import { Col, Row, Skeleton } from 'antd';
import Page from '../../../Component/Page/Page';
import { UserRoles } from '../../../Repository/UserRepository';
import AdminContractsTable from './AdminContractsTable';
import CompassOutlined from "@ant-design/icons/CompassOutlined";
import ModalNewContractFormGeneric from "./ModalNewContractFormGeneric";
import { CONTRACT_CREATED, contractsUnreadable } from '../../../Helper/BannerMessages';

const allowedRoles = [
  UserRoles.Admin
];

interface AdminContractListPageProps{
}

interface AdminContractListPageState{
  contracts?: ContractListData[];
  loading: boolean;
}

export default class AdminContractListPage extends React.Component<AdminContractListPageProps, AdminContractListPageState>{
  static contextType = GlobalContext;
  declare context: React.ContextType<typeof GlobalContext>;

  constructor(props: AdminContractListPageProps) {
    super(props);
    this.state = {
      loading: true,
      contracts: undefined
    }
  }

  async fetchContractList() {
    try {
      await ContractRepository.getAdminContractsList({
        successCallback: (contracts: any) => {
          this.setState({ contracts, loading: false })
        },
        errorCallback: (err: string) => {
          console.error('could not retrieve contracts list', err);
          message.error(contractsUnreadable(String(err)));
          this.setState({ loading: false })
        }
      });
    } catch (error) {
      // Already reported by the errorCallback above: the await must not reject for its callers
      console.error('could not retrieve contracts list', { error });
    }
  }

  async componentDidMount() {
    await this.fetchContractList();
  }

  onUpdate(editedContract: ContractListData, values: any) {
    const { contracts } = this.state;
    contracts && contracts.map((value, idx) => {
      if (value.id === editedContract.id) {
        contracts[idx] = { ...contracts[idx], ...values };
      }
    });
    this.setState({ contracts: JSON.parse(JSON.stringify(contracts)) });
  }

  render() {
    const { loading, contracts } = this.state;

    return <Page {...this.props} hideMenu={false} title={'treeWallet contracts'} allowedRoles={allowedRoles}>
      <Row><Col><h2>Contracts list</h2></Col></Row>
      {loading
        ? <div>
          <Skeleton active />
        </div>
        : <>
          <Row>
            <ModalNewContractFormGeneric
              openButton={<>Create contract <CompassOutlined /></>}
              modalTitle={`New contract`}
              onSave={async (editedObject: any, values: any) => {
                try {
                  const formData = new FormData();
                  Object.entries(values).map(([key, value]: [key: string, value: any]) => {
                    switch (typeof value) {
                      case 'number':
                        formData.append(key, value.toString());
                        break;
                      case 'string':
                        formData.append(key, value);
                        break;
                      case 'object':
                        formData.append(key, JSON.stringify(value.map((current: any) => current.value)));
                        break;
                    }
                  })
                  await ContractRepository.createContract(formData, {
                    successCallback: async () => {
                      message.success(CONTRACT_CREATED);
                      await this.fetchContractList();
                    },
                  });
                } catch (error) {
                  message.error(error);
                }
              }}
            />
          </Row>
          <Row className={'mobile'}>
            <Col>
              <AdminContractsTable
                list={contracts}
                mode={'mobile'}
                onUpdate={this.onUpdate}
              />
            </Col>
          </Row>
          <Row className={'desktop'}>
            <Col>
              <AdminContractsTable
                list={contracts}
                mode={'desktop'}
                onUpdate={this.onUpdate}
                />
            </Col>
          </Row>
        </>
      }
      </Page>
  }
}